import request from "root/js/request";

export const getMarksBrands = async ({
  brand_id,
  end_date__gte,
  end_date__lte,
  start_date__gte,
  start_date__lte,
  limit = 1000,
  offset = 0,
}) => {
  const response = await request({
    url: `/monitoring/marks/brands/`,
    method: "get",
    params: {
      brand_id,
      end_date__gte,
      end_date__lte,
      start_date__gte,
      start_date__lte,
      limit,
      offset,
    },
  });
  return response.data;
};
